/*
* General custom scripts
**/
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

/*
 * Header
 */
import { Header } from './components/Header';
new Header( '.js-page-header' );

/*
 * Header
 */
import { Opacity } from './animations/Opacity';
new Opacity( 'main' );

/*
 * Vacancy
 */
import { Vacancy } from './components/Vacancy';
new Vacancy( '.js-page-header' );

/*
 * SearchPanels
 */
import { SearchPanels } from './components/SearchPanels';
new SearchPanels( 'main' );

/*
 * Parallax
 */
import { Parallax } from './animations/Parallax';
new Parallax( '.fx-parallax' );

/*
 * Geo Switcher
 */
import { GeoSwitcher } from './components/GeoSwitcher';
new GeoSwitcher( );

/*
 * Aside Forms
 */
import { AsideForms } from './components/AsideForms';
new AsideForms( '.aside-forms' );

/*
 * Legal Forms
 */
import { LegalForms } from './components/LegalForms';
new LegalForms( '.js-legal-forms' );

/*
 * WelcomePopup
 */
import { WelcomePopup } from './components/WelcomePopup';
new WelcomePopup( '.c-welcome-popup' );

